import React from "react";
import { Button } from "@vds/buttons";
import { switchTab } from "../../pages/C4S Decommission - Replacement/utils";

const WorkTicketsSuccessModal = ({ show, workTicketNumbers, onClose }) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 99999,
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "8px",
          padding: "32px 28px 24px 28px",
          minWidth: "340px",
          maxWidth: "480px",
          width: "100%",
          boxShadow: "0 4px 24px rgba(0,0,0,0.18)",
          position: "relative",
        }}
      >
        {/* Close X */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "12px",
            right: "16px",
            background: "none",
            border: "none",
            fontSize: "18px",
            cursor: "pointer",
            color: "#333",
            lineHeight: 1,
          }}
          aria-label="Close"
        >
          ✕
        </button>

        <h2 style={{ fontSize: "18px", fontWeight: "700", marginBottom: "8px", marginTop: 0 }}>Work tickets success created</h2>
        <p style={{ fontSize: "13px", color: "#555", marginBottom: "16px", marginTop: 0 }}>
          Your work ticket has been successfully created with the following number:
        </p>

        <div style={{ marginBottom: "24px" }}>
          {workTicketNumbers && workTicketNumbers.length > 0 ? (
            workTicketNumbers.map((wt, i) => (
              <div key={i} style={{ fontSize: "13px", color: "#333", marginBottom: "4px" }}>
                {wt}
              </div>
            ))
          ) : (
            <div style={{ fontSize: "13px", color: "#999" }}>No work ticket numbers available.</div>
          )}
        </div>

        <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
          <Button use="secondary" size="small" onClick={() => switchTab(3)}>
            Ok
          </Button>
          {/* <Button
            size="small"
            onClick={() => {
              onClose();
              switchTab(5, {});
            }}
          >
            Go to the vehicle management
          </Button> */}
        </div>
      </div>
    </div>
  );
};

export default WorkTicketsSuccessModal;
